import { render, staticRenderFns } from "./BaseAppLayout.vue?vue&type=template&id=f2f00f1a&scoped=true&"
var script = {}
import style0 from "./BaseAppLayout.vue?vue&type=style&index=0&id=f2f00f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f00f1a",
  null
  
)

export default component.exports